<template>
  <div>
    <action-header
      v-if="!hasValidRole(role, [Role.Student, Role.Family])"
      :button="buttonSearch"
      :data.sync="studentCode"
      @studentValue="studentCode = $event"
      :pathConnect="pathConnect"
      :validationColumn="validationColumn"
      @export-pdf="exportPdf()"
      :show-export="showExport"
      ref="actionHeader"
    >
    </action-header>
    <div v-else class="md-layout hidden lg:block">
      <div class="md-layout-item text-right">
        <md-button
          class="md-warning"
          @click.prevent="exportPdf()"
          v-if="showExport"
        >
          {{ $t("common.export") }}
        </md-button>
      </div>
    </div>
    <student-information :data="infoStudent">
      <md-card class="rounded-xl">
        <md-card-header class=" md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">{{ $t("smi_sri.act_detail") }}</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div v-if="actScoreTable">
            <md-table class="format-table">
              <md-table-row>
                <md-table-head
                  class="text-center px-0"
                  v-for="(header, index) in headers"
                  :key="'table header' + index"
                >
                  <span class="pl-4">{{ $t(header) }}</span>
                </md-table-head>
              </md-table-row>

              <template>
                <md-table-row
                  class="text-center"
                  v-for="(scoreTable, index) in actScoreTable"
                  :key="index + 'scoreTable'"
                >
                  <md-table-cell
                    >{{ convertDateFromServer(scoreTable.testDate, "date") }}
                  </md-table-cell>
                  <md-table-cell
                    >{{ scoreTable.actCompositeScore }}
                  </md-table-cell>
                  <md-table-cell>{{ scoreTable.actMathScore }}</md-table-cell>
                  <md-table-cell>{{
                    scoreTable.actScienceScore
                  }}</md-table-cell>
                  <md-table-cell>{{
                    scoreTable.actEnglishScore
                  }}</md-table-cell>
                  <md-table-cell>{{
                    scoreTable.actReadingScore
                  }}</md-table-cell>
                </md-table-row>
              </template>
            </md-table>
          </div>
          <div v-else>
            <no-data-found></no-data-found>
          </div>
        </md-card-content>
      </md-card>
    </student-information>
    <div v-if="showExport">
      <pdf-default ref="pdfContent" pdf-format="letter">
        <template #pdf-content>
          <export-pdf-act
            :info="infoStudent"
            :data-table="actScoreTable"
          ></export-pdf-act>
        </template>
      </pdf-default>
    </div>
  </div>
</template>
<script>
import ActionHeader from "./ActionHeader";
import { service_names } from "@/constants/Services";
import StudentInformation from "../Components/StudentInfomation";
import AWSConst from "@/constants/AWS";
import { getId, convertObj, Message } from "@/helpers/utils";
import pick from "lodash/pick";
import { mapGetters, mapState } from "vuex";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import { convertDateFromServer } from "../../../helpers/datetime-helper";
import PdfDefault from "../../../components/PdfDefault";
import ExportPdfAct from "./ExportPdfAct";

const defaultHeader = [
  "smi_sri.test_date",
  "smi_sri.act_composite_score",
  "smi_sri.act_math_score",
  "smi_sri.act_science_score",
  "smi_sri.act_english_score",
  "smi_sri.act_reading_score"
];

export default {
  components: { ExportPdfAct, PdfDefault, StudentInformation, ActionHeader },
  data() {
    return {
      buttonSearch: {
        title: "common.search",
        action: this.getACTStudentInfo
      },
      studentCode: null,
      actScoreTable: null,
      infoStudent: null,
      pathConnect: {
        templateLinks: `${service_names.school}/act/template`,
        templateName: "template-act.xlsx",
        pathSaveUploadedLink: `${service_names.school}/act/import`,
        S3ImportACTPath: AWSConst.S3_IMPORT_ACT_PATH
      },
      validationColumn: {
        validations: {}
      },
      Role,
      hasValidRole,
      convertDateFromServer,
      showExport: false,
      headers: defaultHeader
    };
  },
  watch: {
    studentCode: function() {
      this.infoStudent = null;
      this.actScoreTable = null;
      this.showExport = false;
    }
  },
  computed: {
    ...mapState("switchAccountChild", ["currentChild"]),
    ...mapGetters("user", ["role", "info"])
  },
  mounted() {
    if (hasValidRole(this.role, Role.Student)) {
      this.studentCode = getId(this.info);
      this.getACTStudentInfo();
    }

    if (hasValidRole(this.role, Role.Family)) {
      this.studentCode = getId(this.currentChild);
      this.getACTStudentInfo();
    }

    const query = this.$route.query;
    if (!hasValidRole(this.role, Role.Student) && query.tabName === "ACT") {
      this.setInfoStudentByQuery(query);
    }
  },
  methods: {
    setInfoStudentByQuery(query) {
      this.studentCode = query.id;
      this.getACTStudentInfo();
      this.$router.replace({ query: {} });
    },
    getACTStudentInfo() {
      const studentCode = this.studentCode;
      if (!studentCode) {
        Message.error(
          this.$t("smi_sri.please_select_the_student_to_view_report")
        );
        return;
      }
      return this.$axios
        .get(`${service_names.school}/act/user/${studentCode}`)
        .then(response => {
          if (!response.data) return;
          const data = convertObj.snakeCaseToCamelCase(response.data);
          this.infoStudent = pick(data, [
            "avatarUrl",
            "studentCode",
            "fullName",
            "grade"
          ]);
          if (!hasValidRole(this.role, [Role.Student, Role.Family])) {
            this.$refs.actionHeader.studentData.displayValue =
              this.infoStudent.fullName +
                " - " +
                this.infoStudent.studentCode || "";
          }
          if (data.acts?.length) {
            this.actScoreTable = data.acts;
            this.showExport = true;
          }
        });
    },
    exportPdf() {
      this.$refs.pdfContent.generatePdf();
    }
  }
};
</script>
<style lang="scss">
.format-table {
  th {
    height: 60px;
    .md-table-head-label {
      font-size: 16px;
    }
  }
  th:nth-child(1) {
    padding: 0;
  }
  .crossed {
    background-image: linear-gradient(
      to top right,
      transparent calc(50% - 1px),
      #e5e7eb,
      transparent calc(50% + 1px)
    );
    .cross-cell {
      width: 150px !important;
      .test-date {
        height: 20px;
        line-height: 40px;
      }
      .type {
        height: 20px;
        line-height: 14px;
      }
    }
  }
}
</style>
